import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, MapPinIcon } from 'lucide-react';
const nombres = ['Camila', 'Luciana', 'Valentina', 'Sofía', 'Martina', 'Florencia', 'Agustina', 'Milagros', 'Rocío', 'Julieta', 'Carolina', 'Paula', 'Daniela', 'María', 'Andrea'];
const zonas = ['CABA', 'La Plata', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'San Juan', 'Neuquén', 'Zona Norte GBA', 'Zona Sur GBA', 'Quilmes', 'Pilar', 'Tigre'];
function getRandom<T>(items: T[]): T {
  return items[Math.floor(Math.random() * items.length)];
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    nombre: '',
    zona: ''
  });
  const showToast = useCallback(() => {
    setData({
      nombre: getRandom(nombres),
      zona: getRandom(zonas)
    });
    setVisible(true);
    window.setTimeout(() => setVisible(false), 4500);
  }, []);
  useEffect(() => {
    const first = window.setTimeout(showToast, 18000);
    return () => window.clearTimeout(first);
  }, [showToast]);
  useEffect(() => {
    if (visible) return;
    const next = window.setTimeout(showToast, (Math.floor(Math.random() * 31) + 40) * 1000);
    return () => window.clearTimeout(next);
  }, [visible, showToast]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm" data-id="element-318" data-mp="u8ne57h8grhl">
      <AnimatePresence data-id="element-319" data-mp="ybk1fbhpxbrv">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 28,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 18,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} className="bg-[#0b222c]/95 border border-brand-accent/30 rounded-xl p-3.5 shadow-[0_10px_32px_rgba(0,0,0,0.45)] backdrop-blur-sm" data-id="element-320" data-mp="yahch93yhjel">
            <div className="flex items-start gap-3" data-id="element-321" data-mp="1m2pitv3b4c4a">
              <div className="w-9 h-9 rounded-full bg-brand-accent/15 border border-brand-accent/20 flex items-center justify-center shrink-0" data-id="element-322" data-mp="3j2jzfdxxrkbs">
                <ShoppingBagIcon className="w-4 h-4 text-brand-accent" data-id="element-323" data-mp="3e4qq4c1c6a7a" />
              </div>
              <div className="min-w-0" data-id="element-324" data-mp="3rvvt9o3wxkmd">
                <p className="text-white text-sm font-semibold leading-snug" data-id="element-325" data-mp="3rwouk9k3rhx4">
                  {data.nombre} compró <span className="text-brand-accent" data-id="element-326" data-mp="3n2auhtuhwmm4">Stretching 360™</span>
                </p>
                <p className="text-gray-400 text-xs mt-1 flex items-center" data-id="element-327" data-mp="5pqknaczyae6">
                  <MapPinIcon className="w-3 h-3 mr-1 shrink-0" data-id="element-328" data-mp="o163kqkfelc" />{data.zona}, Argentina · hace unos minutos
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}